import { useRouter } from "next/router";
import constants from "../utils/constants";
function useCheckWorklistContainer() {
  var _useRouter = useRouter(),
    pathname = _useRouter.pathname;
  var worklistRoot = "/".concat(constants.SCREENS.WORKLIST);
  var isWorklist = pathname === worklistRoot || pathname.startsWith("".concat(worklistRoot, "/"));
  if (isWorklist || pathname === "/") {
    return true;
  }
  return false;
}
export default useCheckWorklistContainer;